import { useState } from "react";
import { useLocation, useParams } from "react-router-dom";

import { useGetApplicantChance } from "../../../../hooks/misc";
import { useGetStudentDetails } from "../../../../hooks/students";

import StudentDetailsLayout from "../../../layouts/Student";
import VisaChancesIndicator from "./VisaChancesIndicator";
import VisaChancesList from "./VisaChancesList";
import VisaChancesSwitch from "./VisaChancesSwitch";

import { ChanceResultDisplay } from "../../../../interfaces/services";

const VisaChances = () => {
  const location = useLocation();

  const [filter, setFilter] = useState<ChanceResultDisplay>(ChanceResultDisplay.GOOD);

  const { studentId: studentIdParam } = useParams();
  const studentId = studentIdParam ? parseInt(studentIdParam) : 0;

  const { data: student } = useGetStudentDetails(studentId);

  const chanceType = "study";
  const { data: applicantChance, isLoading, isError, error } = useGetApplicantChance(studentId, chanceType);

  return (
    <StudentDetailsLayout
      goBackRoute={location.state?.goBackRoute ?? null}
      operation='update'
      currentTab="Visa-Chances"
      title={student?.first_name + ' ' + student?.last_name}
      error={false}
      linkedStatus={{
        isDataAvailable: !!studentId,
        linked: !!student?.date_linked,
        linkedDate: student?.date_linked ?? null,
        unlinkedDate: student?.date_unlinked ?? null,
      }}
      isStudentAdded={!!student}
    >
      <div className='immersion__visa_chances'>
        {isLoading ? (
          <div className='immersion__visa_chances__loading'>
            <p> Loading... </p>
          </div>
        ) : isError ? (
          <div className='immersion__visa_chances__error'>
            <p> Error: {error?.message} </p>
          </div>
        ) : applicantChance && applicantChance.chance_results.length > 0 ? (
          <>
            <div className="immersion__visa_chances__container">
              <VisaChancesIndicator chance={applicantChance.chance} />
              <VisaChancesSwitch filter={filter} setFilter={setFilter} />
            </div>
            <VisaChancesList chanceResults={applicantChance.chance_results || []} filter={filter} />
          </>
        ) : (
          <>No records found.</>
        )}
      </div>
    </StudentDetailsLayout>
  );
};

export default VisaChances;